"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.StarRating = exports.Root = exports.NameAndCountry = exports.ImageWrapper = exports.Image = exports.Description = exports.ContentWrapper = exports.ContentInner = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.grey[100],
  justifyContent: 'center',
  height: '100%',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 auto',
    height: 385,
    maxWidth: '100%'
  }
}));
const ContentWrapper = exports.ContentWrapper = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  hasImage
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  order: 2,
  padding: 0,
  [theme.breakpoints.up('sm')]: {
    order: 1,
    alignItems: 'center',
    gap: theme.spacing(4),
    maxWidth: hasImage ? 515 : 600,
    margin: '0 auto',
    padding: theme.spacing(8),
    width: hasImage ? '50%' : '100%'
  }
}));
const ContentInner = exports.ContentInner = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  hasImage
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: hasImage ? 'flex-start' : 'center',
  gap: theme.spacing(3),
  height: hasImage ? 360 : 320,
  margin: theme.spacing(6, 3),
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    height: 'auto',
    gap: theme.spacing(4),
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(4, 3)
  }
}));
const StarRating = exports.StarRating = (0, _mui.styled)(_components.StarRating)(() => ({
  [`& .${_components.starRatingClasses.star}`]: {
    fontSize: '1.4rem',
    margin: 0
  }
}));
const ImageWrapper = exports.ImageWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  [theme.breakpoints.up('sm')]: {
    width: '50%',
    order: 2
  }
}));
const Image = exports.Image = (0, _mui.styled)('img')(({
  theme
}) => ({
  height: 'auto',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    objectFit: 'cover',
    height: 385
  }
}));
const Title = exports.Title = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  fontSize: '1.2rem',
  letterSpacing: '2.4px',
  textTransform: 'uppercase',
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.text.secondary,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitLineClamp: 2
}));
const Description = exports.Description = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'center',
  WebkitLineClamp: 7,
  lineHeight: '1.5',
  fontWeight: theme.typography.fontWeightBold
}));
const NameAndCountry = exports.NameAndCountry = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'center',
  WebkitLineClamp: 1
}));
